import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import authgear from "../authgear";

const redirectURI = process.env.NODE_ENV === "production"
  ? "https://peter-lee-gifford.com/"
  : "http://localhost:3000/";

const Login = () => {
  const navigate = useNavigate();

  useEffect(() => {
    if (authgear.sessionState === "AUTHENTICATED") {
      navigate("/home");
    }
  }, [navigate]);

  const handleLogin = async () => {
    await authgear.startAuthentication({
      redirectURI,
      prompt: "login",
    });
  };

  return (
    <div className="form_container">
      <h2>Login</h2>
      <button onClick={handleLogin}>Login with Authgear</button>
    </div>
  );
};

export default Login;
